import NodeJsVersion3Client from './v3/NodeRest';

export * as V3Types from './v3/data-contracts';

export const Version3Client = NodeJsVersion3Client;

export default NodeJsVersion3Client;
